import { render, staticRenderFns } from "./HotelRoom.vue?vue&type=template&id=8e458fcc&scoped=true&"
import script from "./HotelRoom.vue?vue&type=script&lang=js&"
export * from "./HotelRoom.vue?vue&type=script&lang=js&"
import style0 from "./HotelRoom.vue?vue&type=style&index=0&id=8e458fcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e458fcc",
  null
  
)

export default component.exports